import React from 'react';
import PropTypes from 'prop-types';
import { slugify } from '../../utils';
import Carousel from '../carousel/Carousel';
import { useMediumUpBp } from '../../hooks/useMedia';

const CAROUSEL_SLIDES_TO_SHOW = {
  mobile: 1,
  desktop: 3
};

const BrandsCarousel = ({ title, subtitle, footer, slides, carouselOptions, ...props }) => {
  const isMediumUp = useMediumUpBp();

  const CarouselSlides = slides.map((slide) => (
    <div key={slugify(slide.alt) || slugify(slide.image)} className="brand-slider">
      {slide.link ? (
        <a href={slide.link} rel="noopener noreferrer" target="_blank">
          <img className="brand-image" src={slide.image} alt={slide.alt} />
        </a>
      ) : (
        <img className="brand-image" src={slide.image} alt={slide.alt} />
      )}
      {slide.src && <div className="brand-text" dangerouslySetInnerHTML={{ __html: props[slide.src] }} />}
    </div>
  ));

  return (
    <section className="brands-carousel">
      {title && <h3>{title}</h3>}
      {subtitle && <p>{subtitle}</p>}
      <div className="brands-feed">
        <Carousel
          options={{
            slidesToShow: CAROUSEL_SLIDES_TO_SHOW[isMediumUp ? 'desktop' : 'mobile'],
            ...carouselOptions
          }}
          slides={CarouselSlides}
        />
      </div>
      <p>{footer}</p>
    </section>
  );
};

BrandsCarousel.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  footer: PropTypes.string,
  slides: PropTypes.arrayOf(PropTypes.object),
  carouselOptions: PropTypes.object
};

export default BrandsCarousel;
